import { zodResolver } from '@hookform/resolvers/zod'
import { FileFormSchema, FileFormSchemaType } from 'modules/chat/types/file-form.schema'
import { useForm } from 'react-hook-form'

export const useFileForm = () => {
    return useForm<FileFormSchemaType>({
        resolver: zodResolver(FileFormSchema),
    })
}
